import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { VmeCommonModule } from '../../vme-common.module';
import { VMEComponentsModule } from '../../vme-components.module';
import { VmeDirectivesModule } from '../../vme-directives.module';
import { VmePipesModule } from '../../vme-pipes.module';
import { SupplierFeedbackDetailsComponent } from '../supplier-feedback-details/supplier-feedback-details.component';
import { SupplierFeedbackListComponent } from '../supplier-feedback-list/supplier-feedback-list.component';
import { SupplierFeedbackComponent } from './supplier-feedback.component';

const routes: Routes = [
  {
    path: '',
    component: SupplierFeedbackComponent,
    children: [
      {
        path: '',
        component: SupplierFeedbackListComponent,
        data: { title: 'Supplier Feedback List' },
      },
    ],
  },
  {
    path: ':id',
    component: SupplierFeedbackComponent,
    children: [
      {
        path: '',
        component: SupplierFeedbackDetailsComponent,
        data: { title: 'Supplier Feedback Details' },
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class SupplierFeedbackRoutingModule {}

@NgModule({
  imports: [
    SupplierFeedbackRoutingModule,
    VmeCommonModule,
    VmeDirectivesModule,
    VmePipesModule,
    VMEComponentsModule,
  ],
  declarations: [
    SupplierFeedbackComponent,
    SupplierFeedbackListComponent,
    SupplierFeedbackDetailsComponent,
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class SupplierFeedbackModule {}
